import React, { useState } from "react";
import { FaUserLock, FaUserCheck } from "react-icons/fa6";
import WarningPopup from "./WarningPopup";
import EditPopUp from "./EditPopUp";
import Pagination from "Components/Pagination/Pagination";
import TableLoader from "Components/Common/Loader/TableLoader";

const AllUsers = ({
  users,
  fetchUsers,
  currentPage,
  setCurrentPage,
  totalPages,
  currentTabPermissions,
}) => {
  const [warnPopupOpen, setWarnPopupOpen] = useState(false);
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleOpen = (item) => {
    setWarnPopupOpen(true);
    setSelectedItem(item);
  };

  const handelOpenModal = (item) => {
    setEditPopupOpen(true);
    setSelectedItem(item);
  };

  const handleClose = async () => {
    setLoading(true);
    await fetchUsers(currentPage);
    setLoading(false);
    setWarnPopupOpen(false);
  };

  const handleEditClose = async () => {
    setLoading(true);
    await fetchUsers(currentPage);
    setLoading(false);
    setEditPopupOpen(false);
  };

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    setLoading(true);
    await fetchUsers(page);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <WarningPopup
        selectedItem={selectedItem}
        warnPopupOpen={warnPopupOpen}
        handleClose={handleClose}
      />

      <EditPopUp
        selectedItem={selectedItem}
        editPopupOpen={editPopupOpen}
        handleEditClose={handleEditClose}
      />

      <div className="mx-auto mt-5 w-auto rounded-t-2xl">
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <div className="overflow-x-auto rounded-t-2xl">
              <table className="w-full rounded-t-2xl text-left text-sm">
                <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                  <tr>
                    <th className="px-6 py-3">Sl No.</th>
                    <th className="px-6 py-3">Name</th>
                    <th className="px-6 py-3">Phone</th>
                    <th className="px-6 py-3">Language</th>
                    {currentTabPermissions?.edit && (
                      <th className="px-6 py-3">Action</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {users?.map((row, index) => (
                    <tr
                      className="text-md bg-white tracking-wide text-gray-700"
                      key={row._id}
                    >
                      <td className="whitespace-nowrap border border-[#ddd9db] px-6 py-4">
                        {(currentPage - 1) * 5 + index + 1}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.fullName}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.phone}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.preferred_Language}
                      </td>

                      {currentTabPermissions?.edit && (
                        <td className="border border-[#ddd9db] px-6 py-4">
                          {row?.is_BlockedUser ? (
                            <div
                              onClick={() => handelOpenModal(row)}
                              className="flex cursor-pointer items-center gap-2"
                            >
                              <FaUserCheck size={22} color="#38e000" />
                              <span className="text-[#38e000]">
                                Unblock User
                              </span>
                            </div>
                          ) : (
                            <div
                              onClick={() => handleOpen(row)}
                              className="flex cursor-pointer items-center gap-2"
                            >
                              <FaUserLock size={22} color="#e00000" />
                              <span className="text-[#e00000]">Block User</span>
                            </div>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default AllUsers;
